import { render, staticRenderFns } from "./nav-user-profile.vue?vue&type=template&id=141ffafa"
import script from "./nav-user-profile.vue?vue&type=script&lang=js"
export * from "./nav-user-profile.vue?vue&type=script&lang=js"
import style0 from "./nav-user-profile.vue?vue&type=style&index=0&id=141ffafa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports